import { MaskLoadingProps } from "./types"
import React from "react"
import { Mask } from "~widgets/mask"
import { Loading } from "~widgets/loading"
import { Text } from "~widgets/text"

const MaskLoading: React.FC<MaskLoadingProps> = ({ color, size, text, ...rest }) => {
  return (
    <Mask {...rest}>
      <Loading color={color} size={size || "large"} />
      {text && <Text style={{ color }}>{text}</Text>}
    </Mask>
  )
}

export default MaskLoading
